<template>
  <div>
    <v-col cols="12" class="mx-auto">
      <div class="mx-auto">
        <v-btn
          v-if="displayBindingGate"
          color="primary"
          outlined
          class="text-none mr-2"
          dark
          rounded
          @click="getPossibleDoorphones"
        >
          привязать домофон
        </v-btn>
      </div>
      <v-card-text v-if="displayMain">{{ displayCardText }}</v-card-text>
      <v-card-text v-if="!displayMain">Нет привязанных домофонов.</v-card-text>
      <v-data-table
        v-if="displayMain"
        class="table"
        item-key="id"
        :items="gate.doorphones"
        :items-per-page="5"
        :headers="headersAttachedDoorphones"
        :footer-props="{
            'items-per-page-options': [5, 10],
          }"
      >
        <template v-slot:item.address="{ item }">
          <router-link class="routerLink" :to="`/doorphones/${item.id}`">
            {{ getDoorphoneAddress(item) }}
          </router-link>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                text
                tile
                small
                v-bind="attrs"
                v-on="on"
                class="btn__icon pa-0"
                width="18"
                height="18"
                @click.stop="$set(dialogRemove, item.id, true)"
              >
                <v-icon size="large">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Отвязать домофон</span>
          </v-tooltip>
          <v-dialog v-model="dialogRemove[item.id]" width="500">
            <BaseDeleteModal
              :active.sync="dialogRemove[item.id]"
              @close="$set(dialogRemove, item.id, false)"
              @submit="excisionGateDoorphone(item.id)"
              messageTitle="Отвязать домофон?"
              messageText="Подтверждая, вы отвяжите домофон."/>
          </v-dialog>
        </template>
      </v-data-table>
    </v-col>

    <v-dialog v-model="popupBindDoorphones" max-width="600" lazy-validation>
      <v-card class='pb-5'>
        <v-progress-linear v-if="loadingListDoorphones" indeterminate color="primary"></v-progress-linear>
        <v-card-title class="headline">
          Привязать домофон
          <v-spacer></v-spacer>
          <v-btn
            icon
            text
            x-large
            class="btn__icon pa-0"
            width="18"
            height="18"
            @click.prevent="popupBindDoorphones = false"
          >
            <v-icon size="x-large">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-col class="px-5 pb-5">
          <v-text-field
            v-model="searchAddress"
            placeholder="Поиск по адресу"
            solo
            outlined
            dense
            hide-details
            flat
          ></v-text-field>
        </v-col>
        <v-col class="px-5 pb-5">
          <v-text-field
            v-model="searchId"
            placeholder="Поиск по id"
            solo
            outlined
            dense
            hide-details
            flat
          ></v-text-field>
        </v-col>
       <v-col class="px-5 pb-5">
         <v-btn color="primary" class="text-none" dense @click="onSearchDoorphones">Поиск</v-btn>
       </v-col>
        <v-col class="px-5 pb-5">
          <v-btn
            color="primary"
            outlined
            class="text-none mr-2"
            rounded
            @click.prevent="addDoorphone()"
          >
            Привязать
          </v-btn>
        </v-col>
        <v-data-table
          class="table row-click mx-5 pb-5"
          :items-per-page="doorphonesPerPage"
          :items="filteredDoorphone"
          :headers="headersTieDoorphones"
          :footer-props="{
            'items-per-page-options': [10, 20, 50, 100],
            'items-per-page-text': 'На странице',
          }"
          item-key="id"
          show-select
          :multi-select="true"
          v-model="selected"
          @click:row="activateShowSelect"
          :page.sync="doorphonesPage"
          :server-items-length="doorphonesTotal"
          @update:page="onDoorphonesPageChange"
          @update:items-per-page="onDoorphonesPerPageChange"
        >
          <template v-slot:item.address="{ item }">
            {{ getDoorphoneAddress(item) }}
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogAddDoorphone" max-width="350">
      <v-card>
        <v-card-title class="headline">Привязать домофон?</v-card-title>
        <v-card-text>Подтверждая, вы привязываете домофон.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            text
            @click.prevent="dialogAddDoorphone = false"
          >
            Отменить
          </v-btn>
          <v-btn
            color="success"
            text
            :loading="loading"
            @click.prevent="bindGateDoorphone()"
          >
            привязать
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import BaseDeleteModal from '@/components/BaseDeleteModal';

export default {
  name: 'BindingDoorphone',
  props: ['id'],
  components: { BaseDeleteModal },
  data: () => {
    return {
      loading: false,
      attachedDoorphones: [],
      filteredDoorphone: [],
      address: '',
      dialogAddDoorphone: false,
      apartmentPrefix: [],
      selected: [],
      dialogRemove: {},
      isDisabled: true,
      popupBindDoorphones: false,
      isSelected: false,
      doorphones: [],
      selectedDoorphones: [],
      serchValue: '',
      serchValueId: '',
      doorphoneId: [],
      loadingListDoorphones: false,
      cachedListDoorphones: null,
      headersTieDoorphones: [
        { text: 'id', value: 'id' },
        { text: 'Адрес', value: 'address', sortable: false },
      ],
      headersAttachedDoorphones: [
        { text: 'id', value: 'id' },
        { text: 'Адрес', value: 'address', sortable: false },
        { text: '', value: 'actions', sortable: false },
      ],
      include: ['mainDoorphones'],
      searchAddress: '',
      searchId: '',
      doorphonesPage: 1,
      doorphonesPerPage: 20,
      doorphonesTotal: 0,
      doorphonesMeta: null,
      doorphonesLinks: null,
    };
  },
  created () {
  },
  computed: {
    ...mapGetters({
      doorphone: 'Doorphone/doorphoneEditDoorphone',
      gate: 'Gate/gateEdit',
      doorphonesArrays: 'Doorphone/doorphonesExpanded',
      roleName: 'roleName',
    }),
    searchFreeDoorphones () {
      if (this.serchValue) {
        return this.filteredDoorphone.filter(doorphone => {
          return doorphone.address.toString().toLowerCase().includes(this.serchValue.toLowerCase());
        });
      }

      if (this.serchValueId) {
        return this.filteredDoorphone.filter(item => {
          return item.id.toString().toLowerCase().includes(this.serchValueId.toLowerCase());
        });
      }
      if (this.attachedDoorphones) {
        return this.filteredDoorphone.filter(doorphone => {
          return !this.attachedDoorphones.includes(doorphone.id);
        });
      }
      return this.filteredDoorphone;
    },
    displayCardText () {
      return 'Привязанные домофоны.';
    },
    displayMain () {
      return !!(this.gate.doorphones[0] && this.$checkPermission('edit_gate'));
    },
    displayBindingGate () {
      return this.$checkPermission('update_gate');
    },
  },
  methods: {
    ...mapActions({
      getDoorphones: 'Doorphone/getExpandedDoorphones',
      getGateInfoEdit: 'Gate/getGateInfoEdit',
      updateGate: 'Gate/updateGate',
    }),
    activateShowSelect (value) {
      const index = this.selected.indexOf(value);

      if (index === -1) {
        this.selected.push(value);
      } else {
        this.selected.splice(index, 1);
      }
      this.isDisabled = this.selected.length === 0;
    },
    async getData () {
      await this.getGateInfoEdit({
        id: this.$route.params.id,
      })
        .then(() => {})
        .catch(() => {
          this.$flash_warning('Ошибка при загрузке информации');
        });
    },
    async getPossibleDoorphones () {
      if (this.cachedListDoorphones) {
        this.filteredDoorphone = this.cachedListDoorphones;
        this.popupBindDoorphones = true;
        return;
      }
      this.popupBindDoorphones = true;
      this.loadingListDoorphones = true;
      await this.loadDoorphones();
    },
    addDoorphone () {
      if (this.selected[0]) {
        this.doorphones.push(this.selected);
        this.dialogAddDoorphone = true;
      } else {
        this.$flash_danger('Выберите домофон');
      }
    },
    getDoorphoneAddress (doorphone) {
      let address = doorphone.address;
      if (doorphone.entrance > 0) {
        address = `${doorphone.address}, п.${doorphone.entrance}`;
      }
      return address;
    },
    excisionGateDoorphone (idDelete) {
      const doorphoneId = this.gate.doorphones.map(item => item.id);
      const filteredArray = doorphoneId.filter(id => id !== idDelete);
      this.listDoorphonesdelete = filteredArray.length > 0 ? filteredArray : [];

      const tempGate = {
        device_id: this.gate.gate.device_id,
        physical_status: this.gate.gate.physical_status,
        address: this.gate.gate.address,
        doorphones: this.listDoorphonesdelete,
      };
      if (this.gate.gate.region && this.isDistrict) {
        tempGate.region_id = this.gate.gate.region;
      }
      if (this.gate.gate.name) {
        tempGate.name = this.gate.gate.name;
      }
      this.updateGate({
        id: this.$route.params.id,
        params: tempGate,
      })
        .then(() => {
          this.$flash_success('Изменения успешно сохранены');
          this.getData();
        })
        .catch(() => {
          this.$flash_warning('Ошибка при редактирование контроллера');
        });
    },
    bindGateDoorphone () {
      const doorphones = this.doorphones[this.doorphones.length - 1].slice();
      const doorphonesIdAttached = [];
      this.selectedDoorphones = doorphones.map(doorphone => ({
        id: doorphone.id,
        address: doorphone.address,
      }));
      if (this.gate.doorphones) {
        this.gate.doorphones.forEach(item => {
          doorphonesIdAttached.push(item.id);
        });
      }
      const doorphoneIds = this.selectedDoorphones.map(doorphone => doorphone.id);
      this.combinedArrayId = [...new Set([...doorphoneIds, ...doorphonesIdAttached])];
      const tempGate = {
        device_id: this.gate.gate.device_id,
        physical_status: this.gate.gate.physical_status,
        address: this.gate.gate.address,
        doorphones: this.combinedArrayId,
      };
      if (this.gate.gate.region && this.isDistrict) {
        tempGate.region_id = this.gate.gate.region;
      }
      if (this.gate.gate.name) {
        tempGate.name = this.gate.gate.name;
      }

      this.popupBindDoorphones = false;
      this.dialogAddDoorphone = false;
      this.cachedListDoorphones = null;
      this.loading = false;
      this.selected = [];
      this.selectedDoorphones = [];
      this.value = '';
      this.serchValue = '';
      this.serchValueId = '';
      this.loading = true;
      this.updateGate({
        id: this.$route.params.id,
        params: tempGate,
      })
        .then(() => {
          this.$flash_success('Домофон успешно Привязан');
          this.getData();
        })
        .catch((err) => {
          console.error(err);
          if (err.response && err.response.status === 422) {
            const error = err.response.data.gate;
            error.forEach(item => {
              this.$flash_danger('Ошибка: ' + item);
            });
          } else {
            this.$flash_warning('Ошибка при привязки домофона');
          }
          this.selectedDoorphones = this.selectedDoorphones.filter(doorphone => this.doorphoneId.includes(doorphone.id));
        })
        .finally(() => {
          // this.loading = true;
          this.cancelBindDoorphone();
        });
    },
    cancelBindDoorphone () {
      this.popupBindDoorphones = false;
      this.dialogAddDoorphone = false;
      this.cachedListDoorphones = null;
      this.loading = false;
      this.selected = [];
      this.selectedDoorphones = [];
      this.value = '';
      this.serchValue = '';
      this.serchValueId = '';
    },
    loadDoorphones (page = 1) {
      this.loadingListDoorphones = true;
      return this.getDoorphones({
        pagination: 1,
        page: page,
        limit: this.doorphonesPerPage,
        filters: {
          type: 'M',
          address: this.searchAddress,
          id: this.searchId,
        },
        include: this.include,
      })
        .then((data) => {
          if (this.gate.doorphones[0]) {
            this.attachedDoorphones = this.gate.doorphones.map(doorphone => doorphone.id);
          } else {
            this.attachedDoorphones = [];
          }
          // Убираем уже привязанные домофоны
          this.filteredDoorphone = data.doorphones.filter(d => !this.attachedDoorphones.includes(d.id));
          this.doorphonesMeta = data.meta;
          this.doorphonesLinks = data.links;
          this.doorphonesTotal = data.meta ? data.meta.total : 0;
          this.doorphonesPage = page;
        })
        .catch((err) => {
          console.error(err);
          this.$flash_warning('Ошибка при загрузке домофонов');
        })
        .finally(() => {
          this.loadingListDoorphones = false;
        });
    },
    onDoorphonesPageChange (page) {
      this.loadDoorphones(page);
    },
    onDoorphonesPerPageChange (newPerPage) {
      this.doorphonesPerPage = newPerPage;
      this.doorphonesPage = 1;
      this.loadDoorphones(1);
    },
    onSearchDoorphones () {
      this.doorphonesPage = 1;
      this.loadDoorphones(1);
    },
  },
};
</script>

<style lang="scss" scoped>
.routerLink {
  text-decoration: none;
}

.v-application a {
  color: #434850;
}

.row-click {
  cursor: pointer;
}

a:hover.routerLink {
  text-decoration: underline;
}
</style>
